import { render, staticRenderFns } from "./Introduction.vue?vue&type=template&id=371e7036&"
import script from "./Introduction.vue?vue&type=script&lang=ts&"
export * from "./Introduction.vue?vue&type=script&lang=ts&"
import style0 from "./Introduction.vue?vue&type=style&index=0&id=371e7036&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports